// updated file for service requests
import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/MarketPlace/ServiceRequest.css';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import serviceRequestHistoryIcon from '../../../Assets/MarketPlace/serviceRequestHistory.svg';
import filterRequestIcon from '../../../Assets/MarketPlace/filterRequest.svg';
import DropDownTable from '../../Shared/DropDownTable';
import Input from '../../Shared/Input';
import filterIcon from '../../../Assets/MarketPlace/filter.svg';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_REQUEST_SUMMARY_ENDPOINT, SERVICE_REQUEST_ENDPOINT, SERVICE_FILTERSRS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { connect } from 'react-redux';
let apiPath = "", locationStateCheck = "", cancellationStateCheck = "", paymentStateCheck = [], truckStateCheck = [];
class ServiceRequest extends Component {
    constructor(props) {
        super(props)
        this.state = {
            myRequestsData: [],
            locationFilter: "",
            cancellationPolicyFilter: "",
            paymentMethodFilter: [],
            truckTypeRequirementsFilter: [],
            filterRequestFlag: false,
            searchEmptyAfterFilterRequest: false,
            searchRequest: "",
            searchRequestlength: 0,
            datatemporary: [],
            search: "",
            searchlength: 0,
            quotationHisTempData: [],
            errorMessage: false,
            errorMessageMyRequest: false,
            fliterValue: 'All',
            fliterValueDropDown: false,
            tempDataEmpty: true,
            quotationHisTempDataSearch: [],
            filterDataValues: [],
            openFilterEmptySearchState: [],
            closedFilterEmptySearchState: [],
            rejectedFilterEmptySearchState: [],
            showQuotationReceived: true,
            showServiceDetails: false,
            requestHistoryNotFound: false,
            myRequestNotFound: false,
            quotationHisDetails: [],
        }
        this.handlechangeSearchTransportationServiceID = this.handlechangeSearchTransportationServiceID.bind(this);
        this.handlechangeSearchAppointmentNo = this.handlechangeSearchAppointmentNo.bind(this);
    }
    openFilterEmptySearch = [];
    openFilter = [];
    closedFilterEmptySearch = [];
    closedFilter = [];
    rejectedFilterEmptySearch = [];
    rejectedFilter = [];
    truckdatafilterAll = [];
    truckdatafilterOpen = [];
    truckdatafilterClosed = [];
    truckdatafilterRejected = [];
    componentDidMount = () => {
        this.getRequestHistory();
        this.getQuotationHistory();
        if (this.props.history.location.state?.filterRequestFlag) {
            locationStateCheck = this.props.history.location.state?.locationFilter;
            cancellationStateCheck = this.props.history.location.state?.cancellationPolicyFilter;
            paymentStateCheck = this.props.history.location.state?.paymentMethodFilter;
            truckStateCheck = this.props.history.location.state?.truckTypeRequirementsFilter;
            this.filterRequestGetPath();
            this.setState({
                filterRequestFlag: this.props.history.location.state?.filterRequestFlag,
                locationFilter: locationStateCheck,
                cancellationPolicyFilter: cancellationStateCheck,
                paymentMethodFilter: paymentStateCheck,
                truckTypeRequirementsFilter: truckStateCheck,
                showQuotationReceived: false,
                showServiceDetails: true
            }, () => this.getMyRequestFilterData());
        }
    }
    getRequestHistory = () => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_REQUEST_SUMMARY_ENDPOINT + `?roleType=Respondent`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                    this.setState({ errorMessage: true, requestHistoryNotFound: true });
                }
                else {
                    console.log('I am 200!');
                    this.setState({
                        quotationHisDetails: apiData
                    })
                }
            }
        });
    }
    getQuotationHistory = () => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_FILTERSRS_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                    this.setState({ errorMessageMyRequest: true, myRequestNotFound: true });
                }
                else {
                    console.log('I am 200!');
                    this.setState({
                        myRequestsData: apiData,
                    })
                }
            }
        });
    }
    getMyRequestFilterData = () => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_FILTERSRS_ENDPOINT + apiPath,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    console.log(apiData, "mockData");
                    this.setState({
                        datatemporary: apiData,
                    })
                }
            }
        });
    }
    handlechangeSearchTransportationServiceID = (e) => {
        this.setState({
            searchRequest: e.target.value,
            searchRequestlength: e.target.value.length
        });
    };
    handleFilter = () => {
        this.props.history.push('/FilterRequests');
    }
    searchTransportationService = () => {
        if (this.state.searchRequestlength > 0) {
            const datafilter = this.state.myRequestsData.filter(i => i.serviceRequestId == this.state.searchRequest)
            this.setState({ datatemporary: datafilter });
            console.log("inside search function", this.state.datatemporary);
            if (this.state.filterRequestFlag) {
                this.setState({ searchEmptyAfterFilterRequest: true });
            }
        }
    }
    handleRequestContainer = (index) => {
        this.state.datatemporary.find((dataStorage) => {
            if (dataStorage.serviceRequestId == this.state.datatemporary[index].serviceRequestId && dataStorage?.serviceDetail?.serviceType == 'Transportation') {
                this.props.history.push({
                    pathname: `/RespondentTransportationService/Request/${dataStorage?.serviceRequestId}/${dataStorage?.serviceDetail?.serviceType}`,
                    state: {
                        cancellationPolicyFilter: cancellationStateCheck
                    }
                });
            } else if (dataStorage.serviceRequestId == this.state.datatemporary[index].serviceRequestId) {
                this.props.history.push({
                    pathname: `/RespondentTransportationServiceGs/Request/${dataStorage?.serviceRequestId}/${dataStorage?.serviceDetail?.serviceType}`,
                    state: {
                        cancellationPolicyFilter: cancellationStateCheck
                    }
                });
            }
        })
    }
    filterDataValues = [{ name: "All" }, { name: "Open" }, { name: "Closed" }, { name: "Rejected" }]
    //history 
    handleDetails = (index) => {
        this.state.quotationHisTempData.find((truckdataStore) => {
            if (truckdataStore.serviceRequestId == this.state.quotationHisTempData[index].serviceRequestId && truckdataStore?.serviceDetail?.serviceType == 'Transportation') {
                this.props.history.push({
                    pathname: `/RespondentTransportationService/History/${truckdataStore?.serviceRequestId}/${truckdataStore?.serviceDetail?.serviceType}`,
                    state: truckdataStore
                });
            } else if (truckdataStore.serviceRequestId == this.state.quotationHisTempData[index].serviceRequestId) {
                this.props.history.push({
                    pathname: `/RespondentTransportationServiceGs/History/${truckdataStore?.serviceRequestId}/${truckdataStore?.serviceDetail?.serviceType}`,
                    state: truckdataStore
                });
            }
        })
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ fliterValueDropDown: false });
        }
    };
    toggleDropdownCargoPackaging = () => {
        this.setState({ fliterValueDropDown: !this.state.fliterValueDropDown });
    };
    errorMessageDisplayFunction = (dataValue) => {
        if (dataValue.length === 0) {
            this.setState({ errorMessage: true });
        }
        else {
            this.setState({ errorMessage: false });
        }
    }
    changeFilterValue = (event) => {
        const found = this.filterDataValues.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ fliterValue: found.name });
        this.setState({ fliterValueDropDown: !this.state.fliterValueDropDown });
        if (found.name == 'Open') {
            if (this.state.tempDataEmpty) {
                this.openFilterEmptySearch = this.state.quotationHisDetails.filter(i => i.serviceDetail?.status == 'Open')
                console.log('abc--', this.openFilterEmptySearch)
                this.setState({
                    quotationHisTempData: this.openFilterEmptySearch,
                    openFilterEmptySearchState: this.openFilterEmptySearch
                })
                this.errorMessageDisplayFunction(this.openFilterEmptySearch);
            } else {
                this.openFilter = this.state.quotationHisTempDataSearch.filter(i => i.serviceDetail?.status == 'Open')
                console.log('abc--', this.openFilter)
                this.setState({
                    quotationHisTempData: this.openFilter
                })
                this.errorMessageDisplayFunction(this.openFilter);
            }
        } else if (found.name == 'Closed') {
            if (this.state.tempDataEmpty) {
                this.closedFilterEmptySearch = this.state.quotationHisDetails.filter(i => i.serviceDetail?.status == 'Closed')
                console.log('abc----', this.closedFilterEmptySearch)
                this.setState({
                    quotationHisTempData: this.closedFilterEmptySearch,
                    closedFilterEmptySearchState: this.closedFilterEmptySearch
                })
                this.errorMessageDisplayFunction(this.closedFilterEmptySearch);
            } else {
                this.closedFilter = this.state.quotationHisTempDataSearch.filter(i => i.Status == 'Closed')
                console.log('abc----', this.closedFilter)
                this.setState({
                    quotationHisTempData: this.closedFilter
                })
                this.errorMessageDisplayFunction(this.closedFilter);
            }
        } else if (found.name == 'Rejected') {
            if (this.state.tempDataEmpty) {
                this.rejectedFilterEmptySearch = this.state.quotationHisDetails.filter(i => i.Status == 'Rejected')
                console.log('abc----', this.rejectedFilterEmptySearch)
                this.setState({
                    quotationHisTempData: this.rejectedFilterEmptySearch,
                    rejectedFilterEmptySearchState: this.rejectedFilterEmptySearch
                })
                this.errorMessageDisplayFunction(this.rejectedFilterEmptySearch);
            } else {
                this.rejectedFilter = this.state.quotationHisTempDataSearch.filter(i => i.Status == 'Rejected')
                console.log('abc----', this.rejectedFilter)
                this.setState({
                    quotationHisTempData: this.rejectedFilter
                })
                this.errorMessageDisplayFunction(this.rejectedFilter);
            }
        }
        else {
            if (this.state.tempDataEmpty) {
                this.setState({
                    quotationHisTempData: this.state.quotationHisDetails
                })
                this.errorMessageDisplayFunction(this.state.quotationHisDetails);
            } else {
                this.setState({
                    quotationHisTempData: this.state.quotationHisTempDataSearch
                })
                this.errorMessageDisplayFunction(this.state.quotationHisTempDataSearch);
            }
        }
    }
    handlechangeSearchAppointmentNo = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e.target.value.length,
            errorMessage: false
        });
    };
    showQuotationReceivedfunction = () => {
        this.setState({ showQuotationReceived: true, showServiceDetails: false });
    }
    showServiceDetailsfunction = () => {
        this.setState({ showQuotationReceived: false, showServiceDetails: true });
    }
    searchByOrderId = () => {
        if (this.state.searchlength > 0) {
            this.truckdatafilterAll = this.state.quotationHisDetails.filter(i => i.serviceRequestId == this.state.search)
            this.setState({ quotationHisTempDataSearch: this.truckdatafilterAll });
            if (this.state.fliterValue === 'All') {
                console.log('a---', this.truckdatafilterAll);
                this.setState({ quotationHisTempData: this.truckdatafilterAll });
                if (this.truckdatafilterAll.length === 0) {
                    this.setState({ tempDataEmpty: true, errorMessage: true });
                }
                else {
                    this.setState({ tempDataEmpty: false, errorMessage: false });
                }
            }
            if (this.state.fliterValue === 'Open') {
                this.truckdatafilterOpen = this.openFilterEmptySearch.filter(i => i.serviceRequestId == this.state.search)
                console.log('a---', this.truckdatafilterOpen);
                this.setState({ quotationHisTempData: this.truckdatafilterOpen });
                if (this.truckdatafilterOpen.length === 0) {
                    this.setState({ tempDataEmpty: true, errorMessage: true });
                }
                else {
                    this.setState({ tempDataEmpty: false, errorMessage: false });
                }
            }
            if (this.state.fliterValue === 'Closed') {
                this.truckdatafilterClosed = this.closedFilterEmptySearch.filter(i => i.serviceRequestId == this.state.search)
                console.log('a---', this.truckdatafilterClosed);
                this.setState({ quotationHisTempData: this.truckdatafilterClosed });
                if (this.truckdatafilterClosed.length === 0) {
                    this.setState({ tempDataEmpty: true, errorMessage: true });
                }
                else {
                    this.setState({ tempDataEmpty: false, errorMessage: false });
                }
            }
            if (this.state.fliterValue === 'Rejected') {
                this.truckdatafilterRejected = this.rejectedFilterEmptySearch.filter(i => i.serviceRequestId == this.state.search)
                console.log('a---', this.truckdatafilterRejected);
                this.setState({ quotationHisTempData: this.truckdatafilterRejected });
                if (this.truckdatafilterRejected.length === 0) {
                    this.setState({ tempDataEmpty: true, errorMessage: true });
                }
                else {
                    this.setState({ tempDataEmpty: false, errorMessage: false });
                }
            }
            console.log("inside search function", this.state.quotationHisTempData);
        }
    }
    handleServices = () => {
        this.props.history.push('/MyServicesSettings')
    }
    // myRequest search
    locationFilterValue = [];
    cancellationPolicyFilterValue = [];
    paymentMethodFilterValue = [];
    truckTypeRequirementsFilterValue = [];
    tempDataTemporary = [];
    filterRequestGetPath = () => {
        if (!locationStateCheck && cancellationStateCheck && !paymentStateCheck.length > 0 && !truckStateCheck.length > 0) {
            apiPath = `?cancellationPolicy=${cancellationStateCheck}`;
        } else if (locationStateCheck && cancellationStateCheck && !paymentStateCheck.length > 0 && !truckStateCheck.length > 0) {
            apiPath = `?cancellationPolicy=${cancellationStateCheck}&location=${locationStateCheck}`;
        } else if (locationStateCheck && cancellationStateCheck && paymentStateCheck.length > 0 && !truckStateCheck.length > 0) {
            apiPath = `?cancellationPolicy=${cancellationStateCheck}&location=${locationStateCheck}&paymentMethod=${paymentStateCheck}`;
        } else if (!locationStateCheck && cancellationStateCheck && paymentStateCheck.length > 0 && !truckStateCheck.length > 0) {
            apiPath = `?cancellationPolicy=${cancellationStateCheck}&paymentMethod=${paymentStateCheck}`;
        } else if (locationStateCheck && cancellationStateCheck && paymentStateCheck.length > 0 && truckStateCheck.length > 0) {
            apiPath = `?cancellationPolicy=${cancellationStateCheck}&location=${locationStateCheck}&paymentMethod=${paymentStateCheck}&truckTypeFields=${truckStateCheck}`;
        } else if (!locationStateCheck && cancellationStateCheck && !paymentStateCheck.length > 0 && truckStateCheck.length > 0) {
            apiPath = `?cancellationPolicy=${cancellationStateCheck}&truckTypeFields=${truckStateCheck}`;
        } else if (!locationStateCheck && cancellationStateCheck && paymentStateCheck.length > 0 && truckStateCheck.length > 0) {
            apiPath = `?cancellationPolicy=${cancellationStateCheck}&paymentMethod=${paymentStateCheck}&truckTypeFields=${truckStateCheck}`;
        } else if (locationStateCheck && cancellationStateCheck && !paymentStateCheck.length > 0 && truckStateCheck.length > 0) {
            apiPath = `?cancellationPolicy=${cancellationStateCheck}&location=${locationStateCheck}&truckTypeFields=${truckStateCheck}`;
        }
    }
    render() {
        // myRequest search
        if ((this.state.searchRequestlength == 0 && !this.state.filterRequestFlag) || (this.state.searchRequestlength == 0 && this.state.searchEmptyAfterFilterRequest)) {
            this.state.datatemporary = this.state.myRequestsData;
            console.log("inside render search", this.state.datatemporary);
        }
        // QuotationHistory search
        if (this.state.showQuotationReceived) {
            if (this.state.searchlength == 0 && this.state.fliterValue === 'All') {
                this.state.quotationHisTempData = this.state.quotationHisDetails;
            }
            if (this.state.searchlength == 0 && this.state.fliterValue === 'Open') {
                this.state.quotationHisTempData = this.state.openFilterEmptySearchState;
            }
            if (this.state.searchlength == 0 && this.state.fliterValue === 'Closed') {
                this.state.quotationHisTempData = this.state.closedFilterEmptySearchState;
            }
            if (this.state.searchlength == 0 && this.state.fliterValue === 'Rejected') {
                this.state.quotationHisTempData = this.state.rejectedFilterEmptySearchState;
            }
        }
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.ServiceRequestTitle} description={TitleDescription.ServiceRequestDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullTruckAppointment">
                    <div id="csnobox111">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc">Service Requests</small>
                            </div>
                            {this.state.showQuotationReceived &&
                                <div id="ServiceRequestNAcceptMobile"
                                    className="ServiceRequestNNavbarNameRight"
                                    onClick={this.handleServices}
                                >
                                    <img src={serviceRequestHistoryIcon} class=" mr-1 pb-1" id="TransportationServiceNavBarRightHeadingImg" alt="" loading="lazy" />
                                    <small id="TransportationServiceCancelRequest" >My Services</small>
                                </div>
                            }
                        </nav>
                        <hr class="hr1" />
                        {this.state.showQuotationReceived &&
                            <>
                                <nav class="ServiceRequestNMobileNavbar">
                                    <div className="ServiceRequestNNavbarNameRight" onClick={this.handleServices}>
                                        <img src={serviceRequestHistoryIcon} class=" mr-1 pb-1" id="TransportationServiceNavBarRightHeadingImg" alt="" loading="lazy" />
                                        <small id="TransportationServiceCancelRequest" >My Services</small>
                                    </div>
                                </nav>
                                <hr class="hrCDMobile" />
                            </>
                        }
                        <div class="topPartButtonSectionServiceRequestDiv">
                            <div class="topPartInnerButtonSectionTransportationServiceDiv">
                                <div class={this.state.showQuotationReceived ? "ButtonDivRedBorderTransportationService" : "ButtonDivTransportationService"} onClick={this.showQuotationReceivedfunction}>
                                    <small class={this.state.showQuotationReceived ? "buttonNameBlackTransportationService" : "buttonNameRedTransportationService"}>Request History</small>
                                </div>
                                <div class={this.state.showServiceDetails ? "ButtonDivRedBorderTransportationService" : "ButtonDivTransportationService"} onClick={this.showServiceDetailsfunction}>
                                    <small class={this.state.showServiceDetails ? "buttonNameBlackTransportationService" : "buttonNameRedTransportationService"}>My Requests</small>
                                </div>
                            </div>
                        </div>
                        <div class={this.state.showQuotationReceived ? "ServiceRequestMainCard" : "ServiceRequestMyRequestMainCard"}>
                            {this.state.showQuotationReceived ?
                                <div>
                                    {!this.state.requestHistoryNotFound &&
                                        <div class="QuotationHisSearchUprDiv">
                                            <div class="QuotationHisSearchDiv">
                                                <input
                                                    className="appointmentSearch"
                                                    placeholder="Search by Service Request ID"
                                                    autoComplete="off"
                                                    id="quotationHisDropDownCss"
                                                    onChange={this.handlechangeSearchAppointmentNo}
                                                    value={this.state.search}
                                                ></input>
                                                <img onClick={this.searchByOrderId} id="QuotationFilter_imgDrop" src={searchimg} width="16" height="16" />
                                            </div>
                                            <div class="QuotationFilterDiv">
                                                <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                                    <Input
                                                        readOnly name="CargoPackaging" class="input" placeholder=""
                                                        type="text" id="quotationHisDropDownCss" value={this.state.fliterValue}
                                                    />
                                                    <i id="Quotation_imgDrop" onClick={this.toggleDropdownCargoPackaging}>
                                                        <img src={filterIcon} />
                                                    </i>
                                                </div>
                                                {this.state.fliterValueDropDown && (
                                                    <div class="CrtTptReqestDropDowmDiv" >
                                                        <div class="CrtTptReqestDropCard" ref={this.container} >
                                                            {(this.filterDataValues?.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(val) => this.changeFilterValue(val)} id="CrtTptReqestDropRowSize">
                                                                        <small class="" id="CrtTptReqestDropRowText" >{name.name} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    }
                                    <div id="QuotationHisTopDiv">
                                        {!this.state.errorMessage ?
                                            (this.state.quotationHisTempData?.map((name, index) => {
                                                return (
                                                    <div class="QuotationHisMainCardDiv" onClick={() => this.handleDetails(index)}>
                                                        <div class="QuotationHisDivRow" >
                                                            <div class="QuotationHisMainColumn1">
                                                                <div class='QuotationHisMainColumn' id='QuotationDiv1'>
                                                                    <small id="QuotationHisLable">Service Request ID</small>
                                                                    <small id='QuotationHisValue'>{name.serviceRequestId}</small>
                                                                </div>
                                                                <div class='QuotationHisMainColumn' id='QuotationDiv2'>
                                                                    <small id="QuotationHisLable">Service Request Date & Time</small>
                                                                    <small id='QuotationHisValue'>{FormatTimeStamp(name?.serviceDetail?.publishDateTime).timedateToLocale}</small>
                                                                </div>
                                                                <div class='QuotationHisMainColumn' id='QuotationDiv3'>
                                                                    <small id="QuotationHisLable">Service Type</small>
                                                                    <small id='QuotationHisValue'>{name?.serviceDetail?.serviceType}</small>
                                                                </div>
                                                                <div class='QuotationHisMainColumn' id='QuotationDiv4'>
                                                                    <small id="QuotationHisLable">Status</small>
                                                                    <small id={name?.serviceDetail?.status == 'Open' ? 'QuotationHisValueGreen' : "QuotationHisValue"}>{name?.serviceDetail?.status}</small>
                                                                </div>
                                                            </div>
                                                            <div class="QuotationHisArrow" >
                                                                <img src={rightarrow} id="rightarrowimg" height="18" width="18" class="" alt="" loading="lazy" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            }))
                                            :
                                            <div class="NoQuotationHistory">
                                                <small id="nodatamessage1">No result found</small>
                                            </div>
                                        }
                                    </div>
                                </div>
                                :
                                <div>
                                    {!this.state.myRequestNotFound &&
                                        <div class="conCsDivLow199TransportationService">
                                            <div class="csDivLow2Pre1TransportationService">
                                                <input
                                                    className="preSearchTransportationService"
                                                    placeholder="Search by Service Request ID"
                                                    autoComplete="off"
                                                    id="secrchInput1Pre11TransportationService"
                                                    onChange={this.handlechangeSearchTransportationServiceID}
                                                    value={this.state.searchRequest}
                                                ></input>
                                                <img onClick={this.searchTransportationService} id="searchPre_Img12TransportationService" src={searchimg} width="16" height="16" />
                                            </div>
                                            <div class="ServiceRequestFilterContainerDiv" onClick={this.handleFilter}>
                                                <a><small class="ServiceRequestFilterValue">Filter Requests</small>
                                                    <img src={filterRequestIcon} class="ml-2" id="ServiceRequestFilterImg" alt="" loading="lazy" />
                                                </a>
                                            </div>
                                        </div>}
                                    <div class="consDiv1TransportationService">
                                        {!this.state.errorMessageMyRequest ?
                                            (this.state.datatemporary?.map((datatemporary, index) => {
                                                return (
                                                    <div class="outDivInsideTransportationService" onClick={() => this.handleRequestContainer(index)}>
                                                        <div class="secondDivvTransportationService">
                                                            <div class="outerTransportationServiceWholeDataDiv">
                                                                <div class="TransportationServiceWholeDataWithArrowDiv">
                                                                    <div class="TransportationServiceWholeDataDiv">
                                                                        <div class="ServiceRequestRow1Div">
                                                                            <div class="ServiceRequestContent0Div">
                                                                                <small id="QuotationHisLable">Service Request ID</small>
                                                                                <small id="QuotationHisValue">{datatemporary.serviceRequestId}</small>
                                                                            </div>
                                                                            <div class="ServiceRequestContent1Div">
                                                                                <small id="QuotationHisLable">Service Type</small>
                                                                                <small id="QuotationHisValue">{datatemporary?.serviceDetail?.serviceType}</small>
                                                                            </div>
                                                                            <div class="ServiceRequestContent2Div">
                                                                                <small id="QuotationHisLable">Company Name</small>
                                                                                <small id="QuotationHisValue">{datatemporary?.serviceDetail?.requestorCompanyName}</small>
                                                                            </div>
                                                                            <div class="ServiceRequestContent3Div">
                                                                                <small id="QuotationHisLable">Location</small>
                                                                                <small id="QuotationHisValue">{datatemporary?.serviceDetail?.location}</small>
                                                                            </div>
                                                                        </div>
                                                                        <div class="TransportationServiceRow2Div">
                                                                            <div class="ServiceRequestContent0Div">
                                                                                <small id="QuotationHisLable">Requested On</small>
                                                                                <small id="QuotationHisValue">{FormatTimeStamp(datatemporary?.serviceDetail?.publishDateTime).timedateToLocale}</small>
                                                                            </div>
                                                                            <div class="ServiceRequestContent1Div">
                                                                                <small id="QuotationHisLable">Status</small>
                                                                                <small class={datatemporary?.serviceDetail?.status === "Open" || datatemporary?.serviceDetail?.status === "Accepted" ? "TransportationServiceValueGreen" : "TransportationServiceValueRed"}>{datatemporary?.serviceDetail?.status}</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="rightOut1DivTransportationService">
                                                                        <img src={rightarrow} id="rightArrowImgTransportationService" height="16" width="16" class="" alt="" loading="lazy" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>);
                                            }))
                                            :
                                            <div class="NoQuotationHistory">
                                                <small id="nodatamessage1">No result found</small>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="ServiceRequestFooter1">
                    <Footer />
                </div>
                <div class="ServiceRequestFooter2">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        manageProfileDataR: state.manageProfileReducer.data
    }
}
export default connect(mapStateToProps)(ServiceRequest);